import axios from "axios";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { __API_URL__ } from "../../SERVER_URL";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";

const NOTIFICATION_TYPES = ["GENERAL_MESSAGE", "PHOTO_REMIND", "APPOINTMENT_REMINDER"];

const AddNotification = ({ open, onClose, token, id, AllClinics }) => {
  const [noti, setNoti] = useState("");
  const [title, setTitle] = useState("");
  const [customdata, setCustomdata] = useState("");
  const [is_email, setIsEmail] = useState(false);
  const [is_app, setIsApp] = useState(false);
  const [is_sms, setIsSms] = useState(false);
  const [days, setDays] = useState("");
  const [value, setValue] = useState([]);

  const resetState = () => {
    setNoti("");
    setTitle("");
    setCustomdata("");
    setIsEmail(false);
    setIsApp(false);
    setIsSms(false);
    setValue([]);
    setDays("");
  };

  const handleAddDays = () => {
    if (days === "") return;
    setValue((prev) => [...prev, Number(days)]);
    setDays("");
  };

  const handleRemoveDay = (index) => {
    setValue((prev) => prev.filter((_, i) => i !== index));
  };

  const handleClose = () => {
    resetState();
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const obj = {
      is_email,
      is_app,
      is_sms,
      custom_title: title,
      custom_data: customdata,
      notification_type: noti,
      days: value,
      clinic_id: id,
    };

    try {
      await axios.post(`${__API_URL__}/api/clinic/saveClinicNotification/`, obj, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });
      toast.success("Notification added successfully");
      AllClinics();
    } catch (error) {
      toast.error("Failed to add notification");
      console.error(error);
    }

    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Add Notifications
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <form onSubmit={handleSubmit}>
        <DialogContent dividers>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <FormControl size="small" fullWidth>
              <InputLabel>Notification Type</InputLabel>
              <Select
                label="Notification Type"
                value={noti}
                onChange={(e) => setNoti(e.target.value)}
              >
                {NOTIFICATION_TYPES.map((item) => (
                  <MenuItem value={item} key={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {noti !== "APPOINTMENT_REMINDER" && (
              <>
                <TextField
                  label="Custom Title"
                  size="small"
                  fullWidth
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
                <TextField
                  label="Custom Data"
                  size="small"
                  fullWidth
                  multiline
                  rows={3}
                  value={customdata}
                  onChange={(e) => setCustomdata(e.target.value)}
                />
              </>
            )}

            <Box>
              <Typography variant="subtitle2" sx={{ mb: 1 }}>
                Days
              </Typography>
              <Stack direction="row" spacing={1} alignItems="center">
                <TextField
                  size="small"
                  type="number"
                  value={days}
                  onChange={(e) => setDays(e.target.value)}
                  sx={{ flex: 1 }}
                />
                <Button variant="contained" color="error" size="small" onClick={handleAddDays}>
                  Add Days
                </Button>
              </Stack>
              {value.length > 0 && (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
                  {value.map((item, index) => (
                    <Chip
                      key={index}
                      label={item}
                      onDelete={() => handleRemoveDay(index)}
                      size="small"
                    />
                  ))}
                </Box>
              )}
            </Box>

            <Box>
              <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                Notification
              </Typography>
              <Stack direction="row" spacing={2}>
                <FormControlLabel
                  control={<Checkbox checked={is_app} onChange={() => setIsApp(!is_app)} />}
                  label="In App"
                />
                <FormControlLabel
                  control={<Checkbox checked={is_sms} onChange={() => setIsSms(!is_sms)} />}
                  label="SMS"
                />
                <FormControlLabel
                  control={<Checkbox checked={is_email} onChange={() => setIsEmail(!is_email)} />}
                  label="Email"
                />
              </Stack>
            </Box>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" onClick={handleClose}>
            Close
          </Button>
          <Button variant="contained" type="submit">
            Send
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default AddNotification;
